export default __webpack_public_path__ + "static/media/medium-s-hover-icon.9c95f5fd.svg";